import { ChangeEventHandler } from 'react';
import { Button, FormLabel, Group, IconCrossCircle, Input } from '@screentone/core';
import clonedeep from 'lodash.clonedeep';

import { PageModule } from 'data/generated/graphql';
import styles from '../PageModule.module.scss';

interface PageModuleRankedProps {
  pageModule: PageModule;
  onChange: (newPageModule: PageModule) => void;
  viewOnly?: boolean;
}

export const PageModuleRanked = ({ pageModule, onChange, viewOnly = false }: PageModuleRankedProps) => {
  const handleChangeTitle: ChangeEventHandler<HTMLInputElement> = (e) => {
    const newPageModule = clonedeep(pageModule);
    if (newPageModule.uiModuleFields?.rankedModule) {
      newPageModule.uiModuleFields.rankedModule.title = e.target.value;
    }
    onChange(newPageModule);
  };

  const handleClearTitle = () => {
    const newPageModule = clonedeep(pageModule);
    if (newPageModule.uiModuleFields?.rankedModule) {
      newPageModule.uiModuleFields.rankedModule.title = '';
    }
    onChange(newPageModule);
  };

  return (
    <>
      <FormLabel key="title" label="Title" fullWidth>
        <Group gap="xs" className={styles.inputContainer}>
          <Input
            placeholder="Enter title"
            value={pageModule.uiModuleFields?.rankedModule?.title}
            margin={{ bottom: 'sm' }}
            onChange={handleChangeTitle}
            disabled={viewOnly}
            data-testid="page-module-ranked-title"
          />
          {!viewOnly && (
            <Button
              tertiary
              icon={IconCrossCircle}
              className={styles.deleteIcon}
              onClick={handleClearTitle}
            />
          )}
        </Group>
      </FormLabel>
    </>
  );
};
